import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Flex, SimpleGrid, Stack, TabPanel, TabPanels, Tabs, Text, useColorModeValue } from '@chakra-ui/react';
import { useSetting } from 'contexts/SettingContext';
import CButton from 'components/CButton';
import CInput from 'components/CInput';

export default function Setting() {
    const navigate = useNavigate();
    const { getAllConfigDetails, updateConfigDetails } = useSetting();

    const [settingFields, setSettingFields] = useState([]);

    const textColor = useColorModeValue('secondaryGray.900', 'white');

    useEffect(() => {
        fetchAllConfigDetails();
    }, []);

    const fetchAllConfigDetails = async () => {
        const data = await getAllConfigDetails();

        if (data && data.configDetails?.length > 0) {
            setSettingFields(data.configDetails);
        }
    };

    const handleChange = (id, newValue) => {
        setSettingFields(prevFields =>
            prevFields.map((field, i) =>
                field.id === id ? { ...field, value: newValue } : field
            )
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const hasEmptyField = settingFields.some(field => field.value.trim() === "");
        if (hasEmptyField) {
            return;
        }

        try {
            await updateConfigDetails(settingFields)
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Flex direction="column" minH="100vh" align="start" top="0" pt={{ sm: '125px', lg: '75px' }} position="relative" w="100%">
            <Tabs w="100%">
                <TabPanels mt="24px" maxW="100%" w="100%" mx="auto">
                    <TabPanel w="100%" p="0px" mx="auto">
                        <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">
                            Setting Info
                        </Text>
                        <form onSubmit={handleSubmit}>
                            <Flex direction="column" w="100%">
                                <Stack direction="column" spacing="20px">
                                    <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px" w="100%">
                                        {settingFields.length > 0 &&
                                            settingFields.map((settingField) => (
                                                settingField.value === "true" || settingField.value === "false" ? (
                                                    <div className='switch_component'>
                                                        <CInput
                                                            key={settingField.id}
                                                            label={settingField.label}
                                                            type="switch"
                                                            colorScheme="orange"
                                                            value={settingField.value === "true"}
                                                            onChange={(value) =>
                                                                handleChange(settingField.id, value ? "true" : "false")
                                                            }
                                                            w="100%"
                                                            mb="8px !important"
                                                        />
                                                    </div>
                                                ) : (
                                                    <CInput
                                                        key={settingField.id}
                                                        label={settingField.label}
                                                        type="text"
                                                        value={settingField.value}
                                                        required={true}
                                                        w="100%"
                                                        mb="8px !important"
                                                        onChange={(value) => handleChange(settingField.id, value)}
                                                    />
                                                )
                                            ))}
                                    </SimpleGrid>
                                </Stack>
                                <Flex justify="flex-end" align="center" mt="44px" gap="3">
                                    <Button
                                        variant="darkBrand"
                                        fontSize="sm"
                                        borderRadius="10px"
                                        w={{ base: '128px', md: '148px' }}
                                        h="46px"
                                        type="button"
                                        bg="gray"
                                        color="white"
                                        _hover={{ bg: 'gray.600' }}
                                        onClick={() => navigate('/admin/services')}>
                                        Cancel
                                    </Button>
                                    <CButton
                                        w={{ base: '128px', md: '148px' }}
                                        h="46px"
                                        type="submit">
                                        Submit
                                    </CButton>
                                </Flex>
                            </Flex>
                        </form>
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Flex>
    );
}
